import { css, cx } from "@emotion/css"
import React from "react"
import { chartStyles } from "../../../styles"

export type RevenueSwitchprops = {
  checked?: boolean
  onChange: (_: React.ChangeEvent<HTMLInputElement>) => void
  label: string
  options: { left: string; right: string }
  height?: number
  fontWeight?: number
  detailsView?: boolean
}
export default function BaseSwitch(props: RevenueSwitchprops) {
  const { checked, onChange, label, options, height, fontWeight, detailsView } =
    props
  return (
    <>
      <div
        className={
          detailsView
            ? cx(styles.container, chartStyles.drilldownLabel)
            : styles.container
        }
        style={{ height: height || "auto", fontWeight: fontWeight || 700 }}
      >
        <span style={{ color: "var(--white)" }}>{label}:</span>
        <div className={styles.toggle}>
          <label>
            <input
              type="checkbox"
              checked={checked}
              readOnly
              onChange={onChange}
            />
            <span className={styles.slider}>
              <span className={styles.span}>{options.right}</span>
              <span className={styles.span}>{options.left}</span>
            </span>
          </label>
        </div>
      </div>
    </>
  )
}

const styles = {
  container: css`
    display: flex;
    gap: 8px;
    align-items: center;
    font-style: normal;
    font-weight: 700;
    line-height: 15px;

    color: var(--other-blue);
  `,
  toggle: css`
    position: relative;
    width: 96px;
    height: 23px;

    label {
      cursor: pointer;
    }

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }
    input:active + span {
      background-color: #5774fb;
      outline: 1px solid var(--other-glow-green);
      & > span {
        color: var(--white) !important;
      }
    }
    input:hover:not(:active) + span {
      background-color: #98aafe;
      & > span {
        color: var(--white) !important;
      }
    }
  `,
  slider: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: -1px;
    background-color: var(--black);
    border-radius: 20px;
    border: 1px solid var(--other-blue);
    display: inline-flex;
    justify-content: space-around;
    align-items: center;

    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    --left-span-color: var(--dark-grey);
    --right-span-color: var(--white);

    &::before {
      position: absolute;
      content: "";
      width: 48px;
      height: 23px;
      left: 47px;
      bottom: 0;
      background-color: var(--other-blue);
      border-radius: 20px;
    }

    span {
      z-index: 0;
    }

    /* unchecked  */
    span:first-child {
      color: var(--left-span-color);
    }

    span:last-child {
      color: var(--right-span-color);
    }

    /* checked */
    input:checked + & span:first-child {
      --left-span-color: var(--white);
    }

    input:checked + & span:last-child {
      --right-span-color: var(--dark-grey);
    }

    input:checked + &::before {
      -webkit-transform: translateX(-48px);
      -ms-transform: translateX(-48px);
      transform: translateX(-48px);
    }
  `,
  span: css`
    width: 100%;
    text-align: center;
  `,
}
